import type { RootState } from "../store"

export const policiesSelector = (state: RootState) => state.policies
